import { ModuleSidebar } from "@/components/modules/ModuleSidebar";
import { MODULES } from "@/lib/modules/registry";

export function CnuSidebar() {
  return <ModuleSidebar config={MODULES.cnu} />;
}
